<template>
  <div class="project-modal confirmation-modal">
    <div class="project-modal__background"
         @click="$emit('close')"></div>
    <div class="project-modal__inner">
      <div class="project-modal__close"
           @click="$emit('close')">X
      </div>
      <h2>Confirmation</h2>
      <div class="message">{{ message }}</div>
      <div class="actions">
        <button class="button button--secondary"
                @click="$emit('close')">
          {{ labelCancel }}
        </button>
        <button class="button button--primary"
                @click="$emit('confirm')">
          {{ labelConfirm }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Generic confirmation modal that is used on a variety of things.
 *
 * Emits used to trigger something from parent component.
 */
export default {
  name: 'ConfirmationModal',
  props: {
    message: String,
    labelConfirm: { type: String, default: 'Confirm' },
    labelCancel: { type: String, default: 'Cancel' }
  }
}
</script>

<style scoped lang="scss">

.message {
  padding: 10px 0;
}

.confirmation-modal .estimator-modal__inner {
  width: 260px;
}

.actions {
  display: flex;
  justify-content: stretch;
  margin: 0 -5px;
  padding-top: 5px;

  .button {
    margin: 0 5px;
    flex-grow: 1;
  }

}

</style>
